import {
  Box,
  Container,
  ContainerProps,
  Flex,
  Heading,
} from "@chakra-ui/react";

type HeaderBarProps = ContainerProps & {
  title: string;
  description?: string;
};

export default function HeaderBar({
  children,
  title,
  description,
  ...props
}: HeaderBarProps) {
  return (
    <Container {...props} py={0}>
      <Flex
        flex={1}
        justifyContent="space-between"
        alignItems="center"
        pos="relative"
      >
        <Box>
          <Heading as="h1" size="h1" my="24px">
            {title}
            {!!description && <span>{description}</span>}
          </Heading>
        </Box>
        {children}
      </Flex>
    </Container>
  );
}
